
export const getOfferUrl = {
  url: '//data.p4psearch.1688.com/data/ajax/get_premium_offer_list.json',
  type: 'jsonp'
};

export const getSuggestKeywordList = {
  url: "//suggest.1688.com/bin/suggest?type=offer&encode=utf8",
  type: "jsonp"
}

export const getGuessKeywordList = {
  url: "//data.p4psearch.1688.com/data/ajax/search_guess_you_like.json",
  type: "jsonp"
}

export const getOfferPromotionList = {
  url: "//data.p4psearch.1688.com/data/ajax/search_offer_promotion_list.json",
  type: "jsonp"
}
